
import { mixins, Options } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import WithCampaignConstants from '../mixins/WithCampaignConstants';
import MDiscount from './MDiscount.vue';
// import MQRCode from './MQRCode.vue';
// import MQRCodeWithQuestions from './MQRCodeWithQuestions.vue';
import MQuestionnaire from './MQuestionnaire.vue';
import MUrl from './MUrl.vue';

@Options({
  components: {
    MQuestionnaire,
    MDiscount,
    MUrl
    // NOTE: QRCode not reimplemented with Vue3 yet because of difficulties with Vuetify3
    // MQRCode
    // MQRCodeWithQuestions,
  }
})
export default class MRedemption extends mixins(WithCampaignConstants, CampaignWidgetMixin) {}
